import React from 'react';

const GitpodSupport = ({
  width = '16',
  height = '20',
  className,
  color,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      {...rest}
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 20"
      role="img"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M8.5 3L3 6.42847V12.5715L8.5 16L14 12.5715V6.42847L8.5 9.85694"
        stroke="#6E7781"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { GitpodSupport };
